/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Ledgerempty2Inputs */

const zh_adminsubs_ledgerempty2 = /** @type {(inputs: Adminsubs_Ledgerempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无点数记录`)
};

const en_adminsubs_ledgerempty2 = /** @type {(inputs: Adminsubs_Ledgerempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credit records`)
};

const es_adminsubs_ledgerempty2 = /** @type {(inputs: Adminsubs_Ledgerempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin registros de crédito`)
};

/**
* | output |
* | --- |
* | "No credit records" |
*
* @param {Adminsubs_Ledgerempty2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_ledgerempty2 = /** @type {((inputs?: Adminsubs_Ledgerempty2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Ledgerempty2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_ledgerempty2(inputs)
	if (locale === "en") return en_adminsubs_ledgerempty2(inputs)
	return es_adminsubs_ledgerempty2(inputs)
});
export { adminsubs_ledgerempty2 as "adminSubs_ledgerEmpty" }